/* 纠纷调处列表接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'
// 分页
export function queryList (data) {
  return axios({
    url: path.client + '/client/disputeInfo',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

// 保存
export function save (data) {
  return axios({
    url: path.client + '/client/disputeInfo/add',
    method: 'PUT',
    data: data
  })
}

// 修改
export function update (data) {
  return axios({
    url: path.client + '/client/disputeInfo/update',
    method: 'PUT',
    data: data
  })
}

// 删除
export function del (data) {
  return axios({
    url: path.client + '/client/disputeInfo',
    method: 'DELETE',
    data: data
  })
}

// 获取详情
export function get (id) {
  return axios({
    url: path.client + '/client/disputeInfo/id/' + id,
    method: 'GET'
  })
}

// 课程选择框
export function getCurriculumOption (params) {
  return axios({
    url: path.client + '/client/disputeInfo/getCurriculumOption',
    method: 'POST',
    data: params
  })
}

// 销课时间选择框
export function getSignTimeOption (params) {
  return axios({
    url: path.client + '/client/curriculumSignInfo/getSignTimeOption',
    method: 'GET',
    params: params
  })
}
